export enum EnquiryFormFieldIDs {
  IDENTIFICATION_NUMBER_OF_DOCUMENT_TYPE = 'root_identificationNumberByType_identificationNumber',
}
